import { resolveApiDomainName } from '@/helpers/apiContextDomain';
import { getCookie } from '@/helpers/storage';

interface PostSocialMediaParams {
  fileurl: string;
  mediaGroupId: string;
}

interface FetchResponse {
  [key: string]: unknown;
}

const PostSocialMediaApi = async (baseUrl: string, fileurl: string): Promise<FetchResponse> => {
  const webCookieToken = getCookie('token');
  const params: PostSocialMediaParams = {
    fileurl,
    mediaGroupId: 'f67c581d-4a9b-e611-80c2-00155df80332',
  };

  const apiDomainName = resolveApiDomainName({ apiDomainName: baseUrl });

  const response = await fetch(`${apiDomainName}/dxpcore/mediaitems/url`, {
    method: 'POST',
    headers: {
      authorization: `bearer ${webCookieToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw new Error(`Network response was not ok: ${response.statusText}`);
  }

  return response.json();
};

export default PostSocialMediaApi;
